import { v4 as uuidv4 } from 'uuid'
import _ from 'underscore'

export function defineAttributes(modelClass, attributes) {
  attributes.forEach(function (attribute) {
    Object.defineProperty(modelClass.prototype, attribute, {
      get() {
        return this.attributes[attribute]
      },

      set(value) {
        this.attributes[attribute] = value
      },
    })
  })
}

export default class Base {
  static find(id) {
    let model = new this()
    model.id = id
    model.load()
    return model
  }

  constructor(attributes) {
    this.attributes = attributes || {}
    if (attributes) {
      this.id = attributes.id
    }
  }

  get attributes() {
    if (!this._attributes) {
      this._attributes = {}
    }
    return this._attributes
  }

  set attributes(newAttributes) {
    _.extend(this.attributes, newAttributes)
  }

  get isPersisted() {
    return !!this.id
  }

  get cookieName() {
    return ['cce', this.modelName, this.id].join('-')
  }

  save() {
    if (!this.id) {
      this.id = uuidv4()
    }

    localStorage[this.cookieName] = JSON.stringify(this.attributes)
  }

  load() {
    try {
      this.attributes = JSON.parse(localStorage[this.cookieName])
    } catch (SyntaxError) {
      this.attributes = {}
    }
  }
}
